import { API, graphqlOperation } from "aws-amplify";
import { updateProject } from "../../graphql/mutations";
import { participantListValidator } from "./inputFieldValidation.js";

const cleanParticipant = (participant) => ({
  email: typeof participant.email === "string" ? participant.email.trim() : participant.email,
  firstName: typeof participant.firstName === "string" ? participant.firstName.trim() : participant.firstName,
  lastName: typeof participant.lastName === "string" ? participant.lastName.trim() : participant.lastName,
  title: typeof participant.title === "string" ? participant.title.trim() : (participant.title || ""),
});

const UpdateParticipantList = async (project, participantList) => {
  const sanitizedList = (participantList || []).map(cleanParticipant);
  const participantListValidation = participantListValidator.validate(sanitizedList);
  if(!(participantListValidation.error === undefined)){
    throw new Error("Bad request");
  }

  const input = {
    id: project.id,
    projectName: project.projectName,
    participants: sanitizedList
  };

  const updatedProject = await API.graphql(
    graphqlOperation(updateProject,input)
  );
  return updatedProject;
  
};

export default UpdateParticipantList;
